import {
    TOP_LAWFIRMS
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case TOP_LAWFIRMS:
        return action.payload
      default:
        return state
    }
  }